<template>
  <section class="swiper-featured__section" data-color="dark">
    <div class="swiper-featured__container">
        <swiper
          class="swiper-featured linear"
          ref="swiper"
          :breakpoints="{
            320: { slidesPerView: 1.3, spaceBetween: 18 },
            768: { slidesPerView: 4, spaceBetween: 48 },
          }"
          slidesPerView="4"
          :loop="false"
          grab-cursor
          :centered-slides="false"
          :speed="1000"
          :autoplay="{ delay: 2000, disableOnInteraction: false, reverseDirection: false, pauseOnMouseEnter: true }" 
          @swiper="onSwiper"
          @slideChange="onSlideChange"
          @touchStart="onTouchStart"
          @touchMove="onTouchStart"
          @touchEnd="onTouchEnd"
        >
        <swiper-slide 
            v-for="(slide, index) in slides"
            class="swiper-featured__slide"
            :class="{ even: isThirdEvenFromActive(index) }"
          >
            <template v-if="!slide.coming_soon">
              <a 
                :href="slide.permalink" 
                class="swiper-featured__link"
                @mouseover="mouseFollowerTextMouseOver(slide)" 
                @mouseout="mouseFollowerTextMouseOut()">
                <img
                  :src="slide.image_src" 
                  :alt="slide.image_alt" 
                  :width="slide.image_width" 
                  :height="slide.image_height" 
                  class="swiper-featured__image"            
                />
                <div class="swiper-featured__project">
                  <span class="swiper-featured__project-span">{{ slide.post_title }}</span>
                </div>
              </a>
            </template>
            <template v-else>
              <div 
                class="swiper-featured__link disabled" 
                @mouseover="mouseFollowerTextMouseOver(slide)" 
                @mouseout="mouseFollowerTextMouseOut()"
              >
                <img
                  :src="slide.image_src" 
                  :alt="slide.image_alt" 
                  :width="slide.image_width" 
                  :height="slide.image_height" 
                  class="swiper-featured__image"            
                />
                <div class="swiper-featured__project">
                  <span class="swiper-featured__project-span">{{ slide.post_title }}</span>
                </div>
              </div>
            </template>
            <div class="swiper-featured__title">
              {{ slide.tagline_carousel || slide.tagline }}
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </section>
</template>
<script>
import { ref, onMounted } from 'vue';
import { isMobile } from 'mobile-device-detect'
import { Swiper, SwiperSlide } from 'swiper/vue'
import SwiperCore, { Navigation, Autoplay, FreeMode } from "swiper";
import { useAllisStore } from '../../stores/allis';

import 'swiper/css'
/*
:autoplay="{ delay: 0, disableOnInteraction: true }" 
:freeMode="true"
:freeModeMomentum="false"
:speed="1000"
:sticky="true"      
*/

SwiperCore.use([Autoplay, FreeMode]);
export default {
  props: {
    slides: { type: Array },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const allis = useAllisStore();

    let swiper = null;
    let slideIndex = ref(0);
    let totalSlides = ref(0);

    const onSwiper = (swiperInstance) => {
      swiper = swiperInstance;
      slideIndex.value = swiper.realIndex;
      totalSlides.value = swiper.slides.length;
    };

    const onSlideChange = () => {
      slideIndex.value = swiper.realIndex;
      // if(swiper.realIndex === (swiper.slides.length - 4)){
      //   console.log('end');
      //   swiper.autoplay.reverseDirection = true;
      //   swiper.update();
      // }
    };

    const mouseFollowerTextMouseOver = (slide) => {
      allis.isMouseOver = true;
      allis.mouseFollowerText = slide.coming_soon ? 'Coming Soon' : 'View';
      allis.mouseFollowerDisabled = slide.coming_soon;
    }

    const mouseFollowerTextMouseOut = () => {
      allis.isMouseOver = false;
      allis.mouseFollowerText = 'View';
      allis.mouseFollowerDisabled = false;
    }

    const handleSlideTo = (tab) => {
      swiper.slideTo(tab);
    };

    const isActive = (index) => {
      return index === slideIndex.value;
    };

    const isThirdEvenFromActive = (index) => {
      const isOddSlideIndex = slideIndex.value % 2 !== 0;
      const isThirdSlideFromActive = Math.abs(index - slideIndex.value) === 3;
      return isOddSlideIndex && isThirdSlideFromActive;
    };

    const onTouchStart = () => {
      allis.isMouseOver = false;
      allis.isMouseDragging = true;
      swiper.speed = 5000; // Set your desired speed
      swiper.freemode = false; // Set your desired free mode
      swiper.FreeModeMomentum = true;
    };

    const onTouchEnd = () => {
      allis.isMouseDragging = false;
      setTimeout(function() {
        allis.isMouseOver = true;
      }, 500);
    };

    onMounted(() => {
      if (swiper.value) {
        const swiperContainer = swiper.value.$el;
        swiperContainer.addEventListener('touchstart', onTouchStart);
        swiperContainer.addEventListener('touchmove', onTouchStart);
        swiperContainer.addEventListener('touchend', onTouchEnd);
      }
    });

    return {
      allis,
      swiper,
      slideIndex,
      totalSlides,
      onSwiper,
      onSlideChange,
      handleSlideTo,
      isActive,
      isThirdEvenFromActive,
      onTouchStart,
      onTouchEnd,
      isMobile,
      mouseFollowerTextMouseOver,
      mouseFollowerTextMouseOut,
    };
  },
};
</script>

<style lang="scss">
  .swiper-featured {    
    .swiper-wrapper {
      display: flex;
      user-select: none;
      // transition-timing-function: linear; // 
    }

    &__section {
      position: relative;
      padding: 3.2rem 0 6.4rem;
      display: block;
      @media (min-width: 1024px) {
        padding: 10vh 0;
      }
    }
    &__container {
      position: relative;
      grid-column: 1/-1;
      height: 100%;
    }
    &__slide {
      display: flex;
      flex-direction: column;
      gap: 1.4rem;
      &:nth-child(odd) {
        padding-top: 4rem;
        .swiper-featured__title {
          padding-bottom: 12vh;
          order: 2;
          align-self: flex-end;
          text-align: right;
        }
        .swiper-featured__link {
          order: 1;
          &:after {
            transform: translateY(-30%);
            left: 1.8rem;
          }
          &.disabled {
            cursor: default !important;
            &:after {
              transform: translateY(-15%);
            }
          }
        }
        .swiper-featured__project {
          top: 0;
          transform: translateY(-75%);
          @media (min-width: 1024px) {
            transform: translateY(-50%);
            &-span {
              transform: translateY(100%);
            }
          }
        }
      }
      &:nth-child(even) {
        padding-bottom: 3rem;
        .swiper-featured__title {
          order: 1;
          padding-top: 12vh;
        }
        .swiper-featured__project {
          bottom: 0;
          transform: translateY(75%);
          @media (min-width: 1024px) {
            transform: translateY(50%);
            &-span {
              transform: translateY(-100%);
            }
          }
        }
        .swiper-featured__link {
          order: 2;
          &:after {
            transform: translateY(-70%);
            right: 0;
            top: 0;
          }
          &.disabled {
            &:after {
              transform: translateY(-80%);
            }
          }
        }
        @media (min-width: 1024px) {
          &.swiper-slide-active {
            .swiper-featured__title {
              transform: translateX(calc(var(--gutter-desktop-h) + var(--gutter-mobile-h)));
              transition: transform .75s ease;
            }
          }
        }
      }
      @media (min-width: 1024px) {
        &.even {
          .swiper-featured__title {
              transform: translateX(calc(-1 * (var(--gutter-desktop-h) + var(--gutter-mobile-h))));
              transition: transform .75s ease;
            }
        }
      }
    }
    &__image {
      position: relative;
      display: block;
      padding-left: 1.8rem;
      height: 100%;
      object-fit: cover;      
      @media (min-width: 1024px) {
        width: 100%;
        padding: 0;
      }
    }
    &__title {
      padding-left: 1.8rem;
      color: var(--white);
      font-size: 1.8rem;
      line-height: 120%;
      font-family: var(--fontSerifIt);
      transition: transform .5s ease;
      transform: translateX(0);
      width: calc(100% - 9rem);
      @media (min-width: 1024px) {
        padding-left: 0;
        width: calc(100% - calc(var(--gutter-desktop-h) + var(--gutter-mobile-h)));
      }
    }    
    &__link {
      position: relative;
      &:after {
        content: 'view';
        position: absolute;
        z-index: 2;
        width: 8rem;
        height: 8rem;
        text-transform: uppercase;
        border: 1px solid white;
        color: white;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.6rem;
        font-family: var(--fontSerifIt);
        text-align: center;
        @media (min-width: 1024px) {
          display: none;
        }
      }
      &.disabled {
        &:after {
          content: 'Coming Soon';
          opacity: 0.5;
          @media (min-width: 1024px) {
            display: none;
          }
        }
      }
      &:hover {
        .swiper-featured__project-span {
          transform: translateY(0%);
        }
      }
    }
    &__project {
      position: absolute;
      color: white;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      font-size: 7.9vw;
      line-height: 1;
      text-transform: uppercase;
      font-family: var(--fontSerifRg);
      padding-left: 1.8rem;
      @media (min-width: 1024px) {
        overflow: hidden;
        font-size: 2.4vw;
        padding-left: 0;
      }
      &-span {
        transition: transform .5s ease;
      }
    }
  }
  .swiper-contained {
    position: relative;
    grid-column: 1 / -1;
  }
  .swiper-featured {
    height: 80%;
    .swiper-wrapper {
      height: 80%;
    }
    &__slide {
      padding: 2.3rem var(--margin-mobile-gutter);
      @media (min-width: 1024px) {
        padding: 2.3rem var(--margin-desktop-gutter);
      }
      &--single {
        padding-bottom: 5.6rem;
      }
    }
  }

</style>